import * as React from "react"
import { LogoSkeleton, LogoProps } from "./skeleton"

export function DatocmsLogo(props: LogoProps) {
  return (
    <LogoSkeleton {...props} logoName="DatocmsLogo">
      <path
        d="M9.93656 0H0V20H9.93656C14.9061 20 19.8729 15.5226 19.8729 10.0014C19.8729 4.48019 14.9061 0 9.93656 0ZM9.93656 14.544C9.03781 14.5436 8.15934 14.2768 7.41224 13.7772C6.66515 13.2776 6.08297 12.5677 5.73935 11.7372C5.39572 10.9068 5.30607 9.99312 5.48173 9.11172C5.6574 8.23033 6.09048 7.42082 6.72623 6.78556C7.36197 6.15029 8.17182 5.71781 9.05337 5.54278C9.93492 5.36776 10.8486 5.45807 11.6788 5.80229C12.509 6.1465 13.2185 6.72917 13.7176 7.4766C14.2167 8.22403 14.4829 9.10266 14.4826 10.0014C14.4826 10.5982 14.365 11.1892 14.1365 11.7406C13.908 12.2919 13.5731 12.7928 13.1509 13.2147C12.7288 13.6366 12.2276 13.9711 11.676 14.1992C11.1245 14.4273 10.5334 14.5444 9.93656 14.544Z"
        fill="url(#paint0_linear_1866_31399)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1866_31399"
          x1="0"
          y1="9.99987"
          x2="19.8729"
          y2="9.99987"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF593D" />
          <stop offset="1" stopColor="#FF7751" />
        </linearGradient>
      </defs>
    </LogoSkeleton>
  )
}
